const uk = {
  code: 'uk',
  short: 'UA',
  label: 'Українська',
  native: 'Українська',
  hero: {
    badge: 'Клінінгові послуги • Братислава',
    title: 'Чистий простір. Ясна голова.',
    lead: 'Надійне прибирання квартир та офісів із прозорими цінами та простою броню.',
    cta: 'Замовити',
    whatsapp: 'WhatsApp'
  },
  header: {
    home: 'Головна',
    services: 'Послуги',
    contact: 'Контакти',
    book: 'Замовити',
    whatsapp: 'WhatsApp',
    language: 'Мова'
  },
  home: {
    licensed: 'Ліцензовано • Застраховано • Засоби включені',
    firstCleanDiscountBadge: '10 %',
    firstCleanDiscount: 'Знижка на перше прибирання',
    servicesTitle: 'Наші послуги',
    seeDetails: 'Деталі →',
    whyTitle: 'Чому Sparklean?',
    reasons: [
      'Надійна й перевірена команда спеціалістів',
      'Виконавці з рекомендаціями та підтвердженим досвідом',
      'Гнучкі слоти, включно з вечорами',
      'Фіксовані ціни, без прихованих зборів'
    ],
    areaTitle: 'Покриття',
    areaCopy: 'Братислава та околиці.',
    quote: 'Отримати пропозицію'
  },
  optional: 'необов’язково',
  servicesPage: {
    title: 'Послуги',
    subtitle: 'Натисніть на картку, щоб побачити повний перелік робіт, галерею та цінові примітки.'
  },
  notFound: {
    message: 'Сторінку не знайдено.',
    back: 'На головну'
  },
  serviceDetail: {
    notFound: 'Послугу не знайдено',
    back: 'Назад до послуг',
    bookThis: 'Замовити цю послугу',
    allServices: 'Усі послуги'
  },
  contact: {
    title: 'Контакти',
    hours: 'Відповідаємо Пн–Сб 8:00–20:00.',
    emailLabel: 'Email',
    phoneLabel: 'Телефон',
    whatsappAvailable: 'Доступні у WhatsApp',
    whatsapp: 'Написати у WhatsApp',
    email: 'Надіслати email',
    office: 'Офіс',
    address: 'Karpatské námestie 10A, Bratislava, Slovakia'
  },
  booking: {
    title: 'Бронювання',
    subtitle: 'Розкажіть нам про приміщення та час. Ми підтвердимо email або WhatsApp.',
    fullName: "Повне ім'я",
    fullNamePlaceholder: 'Анна Коваль',
    serviceField: 'Послуга',
    dateField: 'Бажана дата',
    datePlaceholder: 'ДД-ММ-РРРР',
    timeField: 'Бажаний час',
    nameField: "Ім'я",
    emailField: 'Email',
    phoneField: 'Телефон',
    phonePlaceholder: '+421 900 000 000',
    addressField: 'Адреса',
    addressPlaceholder: 'Вулиця, номер, район',
    notesField: 'Коментарі',
    notesPlaceholder: 'Домашні тварини, паркування, код воріт тощо.',
    submit: 'Надіслати заявку',
    chooseService: 'Обрати послугу',
    pick: 'Обрати',
    successTitle: 'Запит надіслано ✅',
    successLine: 'Дякуємо! Ваш номер:',
    successNote: 'Найближчим часом підтвердимо email або у WhatsApp.',
    calendarMonth: 'long',
    pickerDescription: 'Оберіть потрібний тип прибирання.',
    pickerTip: 'Підказка: це можна змінити пізніше.',
    whatsappAlt: 'або напишіть нам у WhatsApp',
    privacy: 'Ми захищаємо ваші дані. Надсилаючи форму, ви погоджуєтесь на контакт щодо цієї заявки.',
    error: 'Щось пішло не так. Спробуйте ще раз.',
    errorTitle: 'Заявку не надіслано',
    errorMessage: 'Не вдалося надіслати заявку. Спробуйте ще раз або зв’яжіться з нами напряму.',
    errorWhatsapp: 'Відкрити чат WhatsApp',
    errorEmail: 'Написати на email',
    required: 'Обов’язкове поле',
    emailError: 'Введіть коректний email',
    phoneError: 'Використовуйте цифри, +, пробіл або тире',
    minChars: 'Щонайменше 10 символів',
    addressHint: 'Вкажіть вулицю та номер',
    pickerTitle: 'Оберіть послугу',
    calendarTitle: 'Оберіть дату'
  },
  footer: {
    tagline: 'Професійні клінінгові послуги в Братиславі та поруч.',
    rights: 'Усі права захищені.',
    getInTouch: 'Зв’язатися',
    chat: 'Написати у WhatsApp'
  },
  services: [
    {
      slug: 'regular-cleaning',
      title: 'Регулярне прибирання',
      short: 'Підтримуйте чистоту щоденно або щотижнево.',
      intro: 'Регулярне прибирання допомагає зберігати порядок та комфорт.',
      description: [
        'Ми ретельно пилососимо та миємо всі доступні площі, обережно витираємо пил і чистимо кухню та ванну – дім залишається свіжим і доглянутим.',
        'Рекомендована частота: щотижня, раз на два тижні або щомісяця.'
      ],
      bullets: [
        'Пилососіння та миття підлог',
        'Витирання пилу з доступних поверхонь',
        'Дезінфекція кухні та санвузла',
        'Винесення сміття та заміна пакетів'
      ],
      priceNote: '18 € / год • Мінімум 2 години'
    },
    {
      slug: 'general-cleaning',
      title: 'Генеральне прибирання',
      short: 'Баланс між регулярним та глибоким очищенням.',
      intro: 'Детальніше прибирання, ніж звичайна підтримка.',
      description: [
        'Включає всі етапи регулярного прибирання плюс ретельний догляд за кухнею та ванною, зовнішні поверхні техніки, внутрішнє очищення духовки й холодильника, а також догляд за зонами домашніх тварин.',
        'Рекомендована частота: щотижня, кожні два тижні або раз на місяць.'
      ],
      bullets: [
        'Чекліст регулярного прибирання включено',
        'Деталізація кухні та ванної',
        'Очищення духовки та холодильника всередині',
        'Видалення шерсті та прибирання зон тварин (місце годування, лоток)'
      ],
      priceNote: '20 € / год • Мінімум 2 години'
    },
    {
      slug: 'deep-cleaning',
      title: 'Глибоке прибирання',
      short: 'Повне очищення зверху донизу для максимальної свіжості.',
      intro: 'Найдетальніша послуга з фокусом на важкодоступні зони та техніку.',
      description: [
        'Містить кожен крок генерального прибирання, плюс миття вікон зсередини та зовні (де дістати), внутрішнє очищення шаф і глибоку обробку техніки – холодильник, духовка, мікрохвильовка.',
        'За запитом – прибирання балкона. Рекомендовано, коли потрібне повне оновлення простору.'
      ],
      bullets: [
        'Видалення накипу та жиру',
        'Очищення шаф та гардеробів всередині',
        'Вікна зсередини та зовні (доступні)',
        'Глибоке чищення побутової техніки'
      ],
      priceNote: '22 € / год • Мінімум 2 години'
    },
    {
      slug: 'post-construction-cleaning',
      title: 'Прибирання після ремонту',
      short: 'Видалення пилу, фарби та сміття після будівництва.',
      intro: 'Професійне очищення після ремонту чи будівельних робіт.',
      description: [
        'Прибираємо пил, клей, фарбу та сміття, миємо вікна, підлоги, поверхні та ванні кімнати, щоб простір був готовий до заселення – чистий і без пилу.'
      ],
      bullets: [
        'Прибирання будівельного пилу та залишків',
        'Детальне очищення фурнітури, розеток та вимикачів',
        'Миття вікон, рам і підвіконь',
        'Фінальне полірування підлог і поверхонь'
      ],
      priceNote: 'Індивідуальна ціна після огляду'
    },
    {
      slug: 'move-in-move-out',
      title: 'Прибирання при переїзді',
      short: 'Ідеально для нового старту чи здачі житла.',
      intro: 'Детальне прибирання для бездоганної передачі або заселення.',
      description: [
        'Звертаємо увагу на шафи, техніку, плінтуси та фурнітуру, щоб оселя була бездоганною для власника чи нових мешканців.',
        'Чудово перед фотографіями, перевірками чи заселенням.'
      ],
      bullets: [
        'Шафи та шухляди очищені всередині',
        'Дегресування техніки всередині',
        'Протерті вікна та рами',
        'Увага до деталей: плінтуси, вимикачі'
      ],
      priceNote: 'Фіксована пропозиція після швидкого огляду'
    },
    {
      slug: 'office-cleaning',
      title: 'Прибирання офісів',
      short: 'Підтримуйте робочий простір бездоганним.',
      intro: 'Охайний і організований офіс завдяки професійній команді.',
      description: [
        'Глибоко очищаємо всі зони – від робочих місць і переговорних до кухонь та санвузлів – створюємо чисте і гігієнічне середовище.',
        'Досвідчена команда працює точно й непомітно, підтримує професійний імідж і комфортну атмосферу для співробітників та клієнтів.'
      ],
      bullets: [
        'Робочі зони, переговорні, ресепшен',
        'Дезінфекція кухонь і санвузлів',
        'Винесення сміття та сортування',
        'Гнучкий графік поза робочим часом'
      ],
      priceNote: 'Ціна за запитом'
    },
    {
      slug: 'commercial-cleaning',
      title: 'Комерційне прибирання',
      short: 'Професійний сервіс для ресторанів, готелів та магазинів.',
      intro: 'Створіть бездоганний простір для гостей та команди.',
      description: [
        'Надаємо якісне прибирання для ресторанів, готелів, магазинів, салонів, фітнес-центрів та офісів, щоб кожна зона була чистою й гігієнічною.',
        'Увага до деталей – блискучі підлоги та меблі, продезінфіковані кухні та санвузли. Використовуємо екологічні засоби та надійні методи для безпеки й комфорту.',
        'Пропонуємо гнучкі графіки та персоналізовані плани під ваш режим роботи, щоб мінімізувати перерви.'
      ],
      bullets: [
        'Гостьові зони, бек-офіс і склади',
        'Дезінфекція зон дотику',
        'Догляд за твердими підлогами та килимами',
        'Плани під кожен тип бізнесу'
      ],
      priceNote: 'Ціна за запитом'
    },
    {
      slug: 'window-cleaning',
      title: 'Миття вікон',
      short: 'Кришталево чисті вікна зсередини та зовні.',
      intro: 'Прозорі вікна наповнюють простір світлом.',
      description: [
        'Професійно миємо вікна в квартирах, офісах і комерційних приміщеннях – зсередини та зовні (доступні ділянки).',
        'Використовуємо екологічні засоби без розводів; скло блищить, рами чисті. Регулярне миття покращує освітлення та вигляд простору.'
      ],
      bullets: [
        'Внутрішні та доступні зовнішні стекла',
        'Протирка рам, підвіконь і напрямних',
        'Екологічні засоби без розводів',
        'Ідеально для дому, офісу та вітрин'
      ],
      priceNote: '25 € / год • Мінімум 2 години'
    },
    {
      slug: 'carpet-upholstery-cleaning',
      title: 'Чистка килимів і м’яких меблів',
      short: 'Глибоке очищення та оновлення килимів і оббивки.',
      intro: 'Повертаємо м’якість і прибираємо запахи.',
      description: [
        'Видаляємо плями, алергени та накопичення професійною технікою, підібраною до тканини, тож текстиль знову свіжий.',
        'Ідеально як доповнення до глибокого прибирання або самостійне оновлення для завантажених зон.'
      ],
      bullets: [
        'Гаряча екстракція або маловолога методика',
        'Прицільне видалення плям і запахів',
        'Безпечні рішення для делікатних тканин',
        'Швидке висихання для мінімальних пауз'
      ],
      priceNote: 'Ціна залежить від тканини та площі'
    }
  ]
};

export default uk;
